module.exports = __webpack_public_path__ + "static/media/activeCircle.9c050210.svg";